import "@husqvarna/ui-core/dist/ui-core.css";

import { Routes, Route, useLocation } from 'react-router';
import svgSprite from "@husqvarna/ui-core/dist/assets/icons.svg";
import { Settings } from "@husqvarna/ui-core";
import "./shared/styles/colors.scss";
import Login from "./Login/Login";
import AuthenticatedApp from "./AuthenticatedApp";
import { IntlProvider } from "react-intl";
import messages_en from './translations/en.json';
import { useLazyCheckAuthQuery } from "./shared/api/authApi";
import { useEffect } from "react";
import { pushToDataLayer } from "./shared/utils/tracking";
import TagManager from "react-gtm-module";

Settings.iconSpritePath = svgSprite;
Settings.modalPortalTarget = "ui-modal";

const App = () => {
  const translations = new Map<string, any>([["en", messages_en]]);
  const location = useLocation();
  const [trigger, { data: user, isLoading }] = useLazyCheckAuthQuery();

  useEffect(() => {
    // checks if user is authenticated by calling back end.
    trigger();
  }, [location]);

  useEffect(() => {
    if (user?.isAuthenticated && user?.userId) {
      // Set user data in dataLayer for Product Fruits (via GTM)
      const userData: any = {
        username: user.userId,
        event: 'user-data-set'
      };
      
      if (user.userGroups) {
        const groups = user.userGroups.split(',');
        userData.role = groups[0]?.trim();
      }
      
      // Add signUpAt (first project's CreatedWhen) if available
      if (user.firstProjectCreatedWhen) {
        userData.signUpAt = user.firstProjectCreatedWhen;
      }
      
      TagManager.dataLayer({dataLayer: userData});
    }
  }, [user?.isAuthenticated, user?.userId, user?.userGroups, user?.firstProjectCreatedWhen]);

  useEffect(() => {
    if (user?.isAuthenticated && user?.userId) {
      const loginTracked = sessionStorage.getItem('tcsp_login_tracked');
      
      if (loginTracked !== 'true') {
        if (user.userGroups) {
          sessionStorage.setItem('tcsp_user_group', user.userGroups);
        }
        sessionStorage.setItem('tcsp_login_tracked', 'true');
        sessionStorage.setItem('tcsp_user_id', user.userId);
        
        pushToDataLayer({
          event: 'login',
          userId: user.userId
        });
      }
    }
  }, [user?.isAuthenticated, user?.userId, user?.userGroups]);

  // Determine if user is authenticated based on the query result
  const isAuthenticated = user?.isAuthenticated;

  return (
    <Routes>
      <Route 
        path="/*" 
        element={
          isAuthenticated ? <AuthenticatedApp /> :
            <IntlProvider messages={translations.get("en")} locale={navigator.language}>
              <Login isLoading={isLoading} />
            </IntlProvider>
        } 
      />
    </Routes>
);}

export default App;